var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8329",
    "data-name": "Group 8329",
    transform: "translate(-205 -1913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11463",
    "data-name": "Group 11463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7146",
    "data-name": "Group 7146",
    transform: "translate(205 1913)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_960",
    "data-name": "Ellipse 960",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#f3f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ReturnOfPremium",
    transform: "translate(-1683.858 -655.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-rotate-ccw",
    "data-name": "Icon feather-rotate-ccw",
    transform: "translate(1901.858 2582.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16059",
    "data-name": "Path 16059",
    d: "M1.5,6v4.516H6.016",
    transform: "translate(-1.476 -2.012)",
    fill: "none",
    stroke: "#e08940",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16060",
    "data-name": "Path 16060",
    d: "M4.608,19.592A11.317,11.317,0,1,0,7.286,7.822L1.715,13.005",
    transform: "translate(-1.715 -4.514)",
    fill: "none",
    stroke: "#e08940",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.de77037ed7defc3ac795a3ef60294982.svg";
export { ForwardRef as ReactComponent };